import {Component, HostBinding, Input} from '@angular/core';
import {Video} from "../../models/video.model";
import {VideoBoxComponent} from "./video-box.component";
import {VideoHistoryService} from "../../services/video/video-history.service";
import {VideoBookmarkService} from "../../services/video/video-bookmark.service";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {VoiceService} from "../../services/voice/voice.service";

@Component({
  selector: 'app-video-item',
  styleUrls: ['./video-item.component.scss'],
  template: `
    <ng-container *ngIf="video">
      <div class="view-box">

        <div class="place-box">
          <article class="place-list-layout">
            <div class="place-label-list">
              <!-- div *ngIf="video.area1"
                   class="place-label-box main-type{{ GetRegion2Css(video.area1) }}">{{ GetRegion2Name(video.area1) }}</div -->

              <div *ngIf="video.area2"
                   class="place-label-box sub-type{{ GetRegion2Css(video.area1) }}">{{ video.area2 }}</div>

            </div>
          </article>
        </div>

        <div class="badge-box"
             *ngIf="video.new">
          <i class="ic ic-new"></i>
        </div>

        <div class="option-box">
          <article class="bookmark-btn-box">
            <button type="button" class="bookmark-btn {{ getBmCss(video) }}"
                    (click)="ToggleBookmark($event, video)"></button>
          </article>
        </div>

        <div class="img-box">
          <img src="{{ makeYoutubeUrl(video.youtubeId) }}" alt="유튜브 이미지">
        </div>

      </div>
      <div class="info-box"
           [innerHTML]="video.title | resize"></div>
    </ng-container>
  `,
})
export class VideoItemComponent extends VideoBoxComponent {
  @HostBinding('class') override class = 'video-item-box';
  @HostBinding('style.display') styleBlock = 'inline-block';
  @Input() override video?: Video;


  constructor(
    protected override historySvc: VideoHistoryService,
    protected override bmSvc: VideoBookmarkService,
    protected override voice: VoiceService,
    protected override lm: LayoutMgrService,
    protected override globalEventSvc: GlobalEventService,
  ) {
    super(historySvc, bmSvc, voice, lm, globalEventSvc);
  }
}
